import React from 'react'
import BForm from '../components/forms/BForm';

export default function EditCoworkerForm({ onSubmit, btnText, preloadedData, isNew, responseErrors}) {
    const fields = [
      {
        fieldName: "email",
        placeholder: "Email",
        validation: {
          required: true,
        },
      },
      {
        fieldName: "canCustomers",
        placeholder: "Kann Benutzer anzeigen",
        type: "checkbox",
      },
      {
        fieldName: "canBrokers",
        placeholder: "Kann Makler anzeigen",
        type: "checkbox",
      },
      {
        fieldName: "canPartner",
        placeholder: "Kann Kooperationspartner anzeigen",
        type: "checkbox",
      },
      {
        fieldName: "canStatistics",
        placeholder: "Kann Statistiken anzeigen",
        type: "checkbox",
      },
      {
        fieldName: "canRanking",
        placeholder: "Kann Ranking anzeigen",
        type: "checkbox",
      },
      {
        fieldName: "canMessages",
        placeholder: "Kann Nachrichten anzeigen",
        type: "checkbox",
      },
      {
        fieldName: "canNotifications",
        placeholder: "Kann Benachrichtigungen anzeigen",
        type: "checkbox",
      },
    ]

    return (
      <BForm
        preloadedData={preloadedData}
        btnText={btnText}
        submit={onSubmit}
        fields={fields}
        responseErrors={responseErrors}
      />
    );
}
